<script lang="ts">
    import FormField from "@/components/atoms/form/form-field/FormField.vue";
    import { IFormGroupState } from '@/components/atoms/form/form-group/form-group-state.interface';
    import { InputValidator } from '@/components/atoms/form/validation/input-validator.mixin';
    import IconComponent from '@/components/atoms/Icon.vue';
    import { Emit, Prop, mixins, Component } from 'vue-facing-decorator';
    import { IconName, ObjectUtils } from 'webshop-modules';

    @Component({
        components: {
            IconComponent,
            FormField,
        },
    })
    export default class TextField extends mixins(InputValidator) {
        @Prop({ required: true })
        public state!: IFormGroupState;

        @Emit()
        public stateChange(update: IFormGroupState): IFormGroupState {
            return update;
        }

        @Emit()
        public submitAction(): void {
            return undefined;
        }

        readonly IconName: typeof IconName = IconName;

        protected baseValidators = [];

        public elementValue = '';
        public placeholderState = false;
        private timeout: number | null = null;

        public mounted(): void {
            this.elementValue = this.state.value;
            this.placeholderState = this.state.value.length === 0;
        }

        public handleFocusChange(isFocused: boolean): void {
            if (isFocused) {
                this.placeholderState = false;
                return;
            }
            this.placeholderState = this.state.value === '';
        }

        public handleInputChange(event: Event): void {
            const element: HTMLInputElement = event.target as HTMLInputElement;
            this.elementValue = element.value;

            if (this.timeout) {
                clearTimeout(this.timeout);
            }

            if (element.value !== '') {
                this.placeholderState = element.value === '';
            }

            this.timeout = setTimeout(() => {
                const stateUpdate: IFormGroupState = ObjectUtils.clone(this.state);

                stateUpdate.value = element.value;
                stateUpdate.errors = this.validateInput(element.value);
                stateUpdate.valid = stateUpdate.errors === null;
                this.stateChange(stateUpdate);
            }, 300);
        }

        public handleSubmit(): void {
            if (this.config.inlineSubmit) {
                this.submitAction();
            }
        }
    }
</script>

<template>
    <FormField
        :config="config"
        :placeholder-state="placeholderState"
        :error-state="state.errors !== null"
        @submit-action="handleSubmit">
        <input
            class="a-formInput"
            type="text"
            v-on:input="handleInputChange"
            v-on:click="handleFocusChange(true)"
            v-on:blur="handleFocusChange(false)"
            v-on:keyup.enter="handleSubmit"
            :id="config.name"
            :name="config.name"
            :value="elementValue" />
    </FormField>
</template>
